<template>
  <div class="view-wrapper flex flex-col  items-center" :style="{ 'min-height': minWindowHeight || 'auto' }">
    <div class="castr-logo-wrapper mt-3">
      <div class="logo-icon-dot"></div>
      <img class="logo-icon" src="@/assets/castr.svg" alt="Streaming Dashboard - Castr"  />
    </div>
    
    <div v-if="isVerifying" class="flex items-center justify-center min-h-screen">
      <div class="flex flex-col items-center justify-center">
        <Spinner text="Retrieving..." classes="text-dark-8 mt-5" spinner-color="var(--c-dark-8)"
      spinner-size="15px" />
      </div>
    </div>

    <div v-else-if="linkUnavailable" class="flex items-center justify-center min-h-screen">
      <div class="flex flex-col items-center justify-center">
        <IconInviteLinkError />
        <p class="text-[20px] mt-5 font-medium">This event is no longer available.</p>
        <p class="text-[14px] text-surface-8">This stream has been deleted or deactivated. If you believe this is an
          error, please contact the event owner for assistance.</p>
      </div>
    </div>

    <div v-else-if="showThankYou" class="flex items-center justify-center min-h-screen">
      <div class="flex flex-col items-center justify-center">
        <IconThankYou />
        <p class="text-[20px] mt-5 font-medium">Thank You!</p>
        <p>Destination and Information added successfully</p>
      </div>
    </div>

    
    <div v-else class="form">
      <div class="text-center mt-4">
        <p class="text-[20px]">You are invited</p>
        <p class="text-surface-8 text-[14px]">You can stream this event on your social media.</p>
      </div>

      <div class="flex flex-row text-center items-center justify-center mt-5 cursor-pointer">
        <div class="flex flex-row">
          <div class="w-6 h-6 text-surface-8 rounded-full text-[11px]  items-center justify-center flex"
            :class="!showNextStep ? 'bg-[#0062ff] text-white' : ' bg-surface-3'"
            :style="isStepActive ? 'background-color: var(--c-main-1); color: white' : ''">1</div>
          <p class="ml-3  text-[14px]">Information</p>
          <div class="ml-4">
            <IconBase class="text-surface-5 mt-0.5" fill="none">
              <IconChevronRightDouble/>
            </IconBase>
          </div>
        </div>
        <div class="flex flex-row ml-4 cursor-pointer">
          <div class="w-6 h-6 text-surface-8 rounded-full text-[11px] items-center bg-surface-3 justify-center flex"
            :style="showNextStep ? 'background-color: var(--c-main-1); color: white' : ''">2</div>
          <p class="ml-3  text-[14px]">Add channels</p>
        </div>
      </div>

      <div style="background-color: var(--c-dark-2)" class="p-6 rounded-md  md:w-[31rem] sm:w-[20rem] w-[23rem] h-auto  mt-3" @click.stop>
        <div v-if="!showNextStep">
          <h2 class="text-[20px] font-semibold mb-4">Add your information</h2>
          <p class="text-[13px] text-surface-8">Your name</p>
          <FormInput v-model="name" type="text" custom-classes="!bg-[color:var(--c-dark-3)] mt-1" />

          <p class="text-[13px] text-surface-8 mt-3">Email address</p>
          <FormInput v-model="email" type="email" custom-classes="!bg-[color:var(--c-dark-3)] mt-1" />

          <FormButton type="main" class="mt-3 md:ml-[23rem] ml-[15rem] w-20" :disabled="isNextStepDisabled || isLoadingData" @click="handleShowNextStep">
            <template v-if="isLoadingData">
              <div class="flex items-center justify-center w-full h-full">
                <Spinner spinner-size="15px" spinner-color="var(--c-dark-8)" classes="text-dark-8" />
              </div>
            </template>
            <template v-else>
              Next step
            </template>
          </FormButton>
        </div>

        <div v-else>
          <div class="flex justify-between mb-4">
            <div class="flex flex-col">
              <h2 class="text-[20px] font-semibold">Add channels</h2>
              <p class="text-[12px] text-surface-8">
                {{ destinationCountText.prefix }}
                <span :class="destinationCountText.isMax ? 'text-danger' : ''">
                  {{ destinationCountText.count }}
                </span>
                destinations
              </p>
            </div>
            <Tooltip v-if="isAddDisabled" :active="true"
              content="You've reached the maximum number of destinations. Remove one to add a new destination"
              class="ml-2">
              <FormButton @click="$showModal('modal-add-channel')" :disabled="isAddDisabled">Add channels</FormButton>
            </Tooltip>
            <FormButton v-else @click="$showModal('modal-add-channel')" :disabled="isAddDisabled">Add channels</FormButton>
          </div>
          <add-channels-modal :hideSection="true" :stream="stream" :selected-group="selectedGroup"
            @platform-saved="handlePlatformSelected" />
          <div>
            <div class="flex-1 flex justify-center items-center flex-col mt-5" v-if="selectedPlatforms.length === 0">
              <img src="@/assets/icons/noGuestDes.svg" alt="no-destinations">
              <p class="text-[14px] text-surface-6 mt-3">No guest channels have been added yet.</p>
            </div>
            <div v-else>
              <ul>
                <li v-for="(plat, index) in selectedPlatforms" :key="index" class="text-white text-[16px]">
                  <div class="flex flex-row mt-4">
                    <div v-if="!plat.icon" class="ml-4 mr-5 mt-1">
                      <img src="@/assets/icons/cog.svg" />
                    </div>
                    <img v-else :src="getIcon(plat.icon)" />
                    <div class="flex flex-col ml-2">
                      <div v-if="!plat.name" class="text-[15px] font-medium">Custom</div>
                      <div v-else class="text-[15px] font-medium">{{ plat.name }}</div>

                      <div class="flex justify-between items-center w-full md:min-w-[340px] min-w-[220px]">
                        <span class="text-[12px] text-surface-8">{{ plat.server }}</span>
                        <FormButton type="danger" class="w-9 h-10" @click="removePlatform(index)">
                          <IconBinn />
                        </FormButton>
                      </div>

                    </div>
                  </div>
                  <hr class="border-t my-2 mt-4" />
                </li>
              </ul>
            </div>
          </div>
          <div>
            <FormButton type="main" @click="handleSave"
              class="md:ml-[25rem] ml-[17rem] mt-10 h-8 text-[14px]">
              Save
            </FormButton>
          </div>
        </div>
      </div>
      <p v-if="showNextStep" class="text-[14px] text-surface-6 text-center">
        Rest assured: any stream URL or key you enter here is 
        <span class="inline md:hidden"><br /></span>
        encrypted and 
        <span class="hidden md:inline"><br /></span>
        inaccessible to the invitiation sender.
      </p>

      <p v-if="invalidLinkErr" class="text-[14px] text-surface-6 text-center">
        It looks like your email doesn't have permission to  
        <span class="inline md:hidden"><br /></span>
       proceed. Please reach
        <span class="hidden md:inline"><br /></span>
        out to the owner to gain access.
      </p>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import FormButton from '../Atoms/FormButton.vue'
import FormInput from '../Atoms/FormInput.vue'
import AddChannelsModal from './AddChannelsModal.vue'
import IconBinn from '../icon/IconBinn.vue'
import IconThankYou from '../icon/IconThankYou.vue'
import IconInviteLinkError from '../icon/IconInviteLinkError.vue'
import Tooltip from '../Atoms/Tooltip.vue';
import { useRoute } from 'vue-router'
import GuestDestinationService from '../../services/GuestDestinationService'
import { useNotification } from '@kyvg/vue3-notification';
import Spinner from "@/components/ui/Spinner.vue";
import IconBase from '@/components/icon/IconBase.vue';
import IconChevronRightDouble from '@/components/icon/IconChevronRightDouble.vue';
const route = useRoute()
const selectedGroup = ref('someGroupId')
const stream = ref({
  type: 'live'
})

const name = ref('')
const email = ref('')
const isLoadingData = ref(false)
const isVerifying = ref(true)
const showNextStep = ref(false)
const minWindowHeight = ref('0px')
const receivedEmails = ref([
  'test1@gmail.com'
]);
const invalidLinkErr = ref('')
const linkUnavailable = ref(false)

const { notify } = useNotification();

function handleEmailAccess(emailManageList) {
  receivedEmails.value = emailManageList;
}

const getIcon = (icon) => {
  const svgIcon = icon.replace('png', 'svg')

  try {
    return require(`@/assets/images/platforms/${svgIcon}`)
  } catch (err) {
    return require('@/assets/images/platforms/custom.svg')
  }
}

async function handleShowNextStep() {
  isLoadingData.value = true;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  if (name.value.trim() === '' || email.value.trim() === '') {
    notify({ group: 'error', text: 'Please fill in both fields before continuing.' })
    isLoadingData.value = false;
    return
  }

  if (!emailPattern.test(email.value.trim())) {
    notify({ group: 'error', text: 'Please enter a valid email.' })
    isLoadingData.value = false;
    return
  }

  try {
    const res = await GuestDestinationService.verifyGuestEmail({
      email: email.value,
      id: route.params ? route.params.id : '',
    });
    
    if(res.success) {
      if(res.hasSubmitted && res.destinations?.length) {
        //showThankYou.value = true
        const getPlatformIcon = (name) => {
          return GuestDestinationService.getPlatformIcon(name)
        }
        selectedPlatforms.value = res.destinations.map(dest => {
          dest.icon = getPlatformIcon(dest.template || dest.name)
          return dest
        });
      } 
      showNextStep.value = true
    } else {
      invalidLinkErr.value = 'error';
    }
  } catch (e) {
    console.log(e);
    invalidLinkErr.value = 'error';
  }
  isLoadingData.value = false;
}



const props = defineProps({

});

const selectedPlatforms = ref([])
const showThankYou = ref(false)
const maxDestinations = ref(3);

const isAddDisabled = computed(() => {
  return selectedPlatforms.value.length >= maxDestinations.value
})

const isNextStepDisabled = computed(() => {
  return (!email.value || invalidLinkErr.value !== '' || isLoadingData.value)
})

watch(email, (newEmail) => {
  invalidLinkErr.value = ''
})

const destinationCountText = computed(() => {
  const current = selectedPlatforms.value.length
  const max = maxDestinations.value
  const isMax = current >= max
  return {
    prefix: 'You have selected',
    count: `${current}/${max}`,
    isMax
  }
})

function handlePlatformSelected(selectedPlatform) {
  const getPlatformIcon = (name) => {
    return GuestDestinationService.getPlatformIcon(name)
  }
  selectedPlatform.name = selectedPlatform.template;
  selectedPlatform.icon = getPlatformIcon(selectedPlatform.template || selectedPlatform.name)
  selectedPlatforms.value.push(selectedPlatform);
}

function removePlatform(index) {
  selectedPlatforms.value.splice(index, 1)
}

const isStepActive = computed(() => {
  return name.value.trim() !== '' && email.value.trim() !== ''
})

async function handleSave() {
  try {
    const res = await GuestDestinationService.createDestination({
      name: name.value,
      email: email.value,
      id: route.params ? route.params.id : '',
      destinations: selectedPlatforms.value,
    });

    emit('saveInfo', {
      name: name.value,
      email: email.value
    })
  } catch (e) {
    console.log('error', e);
  }

  showThankYou.value = true
}

async function verifyUrl() {
  isVerifying.value = true;
  
  try {
    const res = await GuestDestinationService.verifyGuestUrl({
      id: route.params ? route.params.id : '',
    });
    if(!res.success) {
      linkUnavailable.value = true;
    } else {
      maxDestinations.value = res?.maxDestinations;
      linkUnavailable.value = !res?.maxDestinations;
    }
  } catch (e) {
    console.log('error', e);
  }

  isVerifying.value = false;
}


onMounted(() => {
  verifyUrl();
})
</script>


<style></style>

<style scoped>
.castr-logo-wrapper {
  position: relative;
  display: inline-block;
}

.castr-logo-wrapper .logo-icon-dot {
  position: absolute;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  right: 4px;
  top: 9px;
  background-color: #ec0104;
  -webkit-animation: blink 2s ease-in-out infinite;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.logo-icon {
  width: 100px;
  margin-left: -5px;
}
</style>